import { FC } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import Text from '@/components/ui/custom/dataDisplay/Text';
import { IconWithText } from '@/components/ui/custom/dataDisplay/IconWithText';
import { twMerge } from 'tailwind-merge';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Skeleton from '@/components/ui/custom/Skeleton';

type SelectHeaderProps = {
  label?: string;
  selected?: string;
  loading?: boolean;
  className?: ClassNameComponent;
};

const SelectFilterHeader: FC<SelectHeaderProps> = (
  props: SelectHeaderProps,
) => {
  const { label = '', className, selected = '', loading } = props;
  return (
    <section
      className={twMerge(
        'flex gap-1 items-center cursor-pointer',
        className?.base,
      )}
    >
      <Text
        text={label}
        className={twMerge('text-[0.875rem] lg:text-[1rem]', className?.label)}
      />
      <ConditionalRenderer
        condition={!loading}
        fallback={<Skeleton className="h-4 w-16 bg-secondary rounded-md" />}
      >
        <IconWithText
          icon={<ChevronDownIcon className={twMerge('w-3', className?.icon)} />}
          className={{
            base: twMerge(
              'gap-0.5 text-base-content/70 flex-row-reverse self-center',
              className?.div,
            ),
            text: twMerge(
              'text-14 font-400 text-secondary lowercase',
              className?.text,
            ),
          }}
          text={selected}
        />
      </ConditionalRenderer>
    </section>
  );
};

export default SelectFilterHeader;
